import React from 'react';
import { LegalLayout } from '@/components/layouts/LegalLayout';
import { Separator } from '@/components/ui/separator';

export const MentionsLegales: React.FC = () => {
  return (
    <LegalLayout>
      <div className="prose prose-slate dark:prose-invert max-w-none">
        <h1 className="text-3xl font-bold mb-6">Mentions légales</h1>
        
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Éditeur du site</h2>
          <div className="bg-muted/30 p-4 rounded-lg">
            <p><strong>Nom de la société :</strong> [À remplir]</p>
            <p><strong>Forme juridique :</strong> [SASU / Auto-entrepreneur - À remplir]</p>
            <p><strong>Capital social :</strong> [À remplir si SASU]</p>
            <p><strong>SIRET :</strong> [À remplir]</p>
            <p><strong>N° TVA intracommunautaire :</strong> [À remplir]</p>
            <p><strong>Code APE :</strong> [À remplir]</p>
          </div>
        </section>

        <Separator className="my-6" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Coordonnées</h2>
          <div className="bg-muted/30 p-4 rounded-lg">
            <p><strong>Adresse :</strong> [Adresse complète - À remplir]</p>
            <p><strong>Téléphone :</strong> [Numéro de téléphone - À remplir]</p>
            <p><strong>Email :</strong> [contact@votredomaine.com - À remplir]</p>
          </div>
        </section>

        <Separator className="my-6" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Directeur de la publication</h2>
          <div className="bg-muted/30 p-4 rounded-lg">
            <p><strong>Nom :</strong> [Nom du directeur - À remplir]</p>
            <p><strong>Qualité :</strong> [Gérant / Président - À remplir]</p>
          </div>
        </section>

        <Separator className="my-6" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Hébergement</h2>
          <div className="bg-muted/30 p-4 rounded-lg">
            <p><strong>Hébergeur :</strong> [Nom de l'hébergeur - À remplir]</p>
            <p><strong>Adresse :</strong> [Adresse de l'hébergeur - À remplir]</p>
            <p><strong>Téléphone :</strong> [Téléphone hébergeur - À remplir]</p>
            <p><strong>Site web :</strong> [URL hébergeur - À remplir]</p>
          </div>
        </section>

        <Separator className="my-6" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Propriété intellectuelle</h2>
          <p>
            L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur 
            et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour 
            les documents téléchargeables et les représentations iconographiques et photographiques.
          </p>
          <p className="mt-4">
            La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit 
            est formellement interdite sauf autorisation expresse du directeur de la publication.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-4">Limitation de responsabilité</h2>
          <p>
            Les informations contenues sur ce site sont aussi précises que possible et le site remis à jour 
            à différentes périodes de l'année, mais peut toutefois contenir des inexactitudes ou des omissions.
          </p>
          <p className="mt-4">
            Si vous constatez une lacune, erreur ou ce qui parait être un dysfonctionnement, 
            merci de bien vouloir le signaler par email, à l'adresse [contact@votredomaine.com - À remplir], 
            en décrivant le problème de la manière la plus précise possible.
          </p>
        </section>
      </div>
    </LegalLayout>
  );
};